module.exports = __webpack_public_path__ + "img/add_box.de70877f.svg";